import React, { useEffect, useState } from "react"
import LearnerHealthCard from "../../../components/ui/LearnerHealthCard"
import { computeLearnerHealthBreakdown } from "../../../utils/learnerHealthHelpers"

const LearnerHealthSection = ({ orgId, onNavigate }) => {
  const [breakdown, setBreakdown] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    let cancelled = false
    setLoading(true)
    computeLearnerHealthBreakdown(orgId).then((data) => {
      if (!cancelled) {
        setBreakdown(data)
        setLoading(false)
      }
    })
    return () => {
      cancelled = true
    }
  }, [orgId])

  if (loading || !breakdown) {
    return <div className="h-64 rounded-2xl bg-muted animate-pulse" />
  }

  const categories = [
    { key: "active", label: "Active", value: breakdown.active.count, percent: breakdown.active.percent, color: "emerald", ctaLabel: "View Active Learners" },
    { key: "atRisk", label: "At Risk", value: breakdown.atRisk.count, percent: breakdown.atRisk.percent, color: "amber", ctaLabel: "View At-Risk Learners" },
    { key: "inactive", label: "Inactive", value: breakdown.inactive.count, percent: breakdown.inactive.percent, color: "rose", ctaLabel: "View Inactive Learners" },
  ]

  return (
    <LearnerHealthCard categories={categories} totalLearners={breakdown.total} onView={() => onNavigate?.("learners")} />
  )
}

export default LearnerHealthSection